<template>
  <div id="app" :style="{ 'background-color': params.background }">
    <div id="container_mercedes_logo">
      <div id="mercedes_logo"></div>
    </div>
    <input type="text" :value="input" placeholder="Say something..." @input="checkInput" v-on:keyup="inputSubmit" class="text-input" x-webkit-speech>
    <div class="chat">
      <ul class="chat-content" v-chat-scroll>
        <li v-for="line in conversation" :class="{ 'you': line.who == 'you' }">
          <div class="content">{{ line.text }}</div>
        </li>
      </ul>
    </div>
    <div class="show-wrapper" :class="{ 'active': isSpeaking || isRecognizingAndReceivingInput }">
      <img v-bind:src="speechAnimation" />
      <div class="show-wrapper-text">{{ isRecognizing ? isRecognizingLastInput : '' }}</div>
    </div>
    <div id="button" v-on:click="record" :class="{ 'active': isRecognizing }">
      <span class="ellipse"></span>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="microphone" data-container-transform="translate(3)"
           viewBox="0 0 16 20" x="0px" y="0px">
        <path d="M4.5 0c-1.4 0-2.5 1.1-2.5 2.5v5c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5v-5c0-1.4-1.1-2.5-2.5-2.5zm-4.125 6.188a.5.5 0 0 0-.375.5v.813c0 2.302 1.763 4.184 4 4.438v3.063h-2c-.6 0-1 .4-1 1h7c0-.6-.4-1-1-1h-2v-3.063c2.237-.254 4-2.136 4-4.438v-.813a.5.5 0 1 0-1 0v.813c0 1.927-1.573 3.5-3.5 3.5s-3.5-1.573-3.5-3.5v-.813a.5.5 0 0 0-.563-.5.5.5 0 0 0-.063 0z" transform="translate(3)"/>
      </svg>
      <svg class="shadow" xmlns="http://www.w3.org/2000/svg" height="50" width="50" viewBox="0 0 744.09448819 1052.3622047">
        <ellipse class="eclipse" cx="380" cy="520" rx="500" ry="500" fill="#DBDBDB" fill-rule="evenodd" />
      </svg>
      <svg class="shadow2" xmlns="http://www.w3.org/2000/svg" height="50" width="50" viewBox="0 0 744.09448819 1052.3622047">
        <ellipse class="eclipse" cx="380" cy="520" rx="500" ry="500" fill="#DBDBDB" fill-rule="evenodd" />
      </svg>
      <div id="contents"></div>
    </div>
    <div id="viz1" class="visual"></div>
    <div id="viz2" class="visual"></div>
    <div id="viz3" class="visual"></div>
    <div id="viz4" class="visual"></div>
    <div id="tip" style="display: none;">Press and hold to speak</div>
    <transition name="modal">
      <div class="modal" v-if="'results' in news">
        <div class="modal-content">
          <div class="close" v-on:click="closeNews()">x</div>
          <div class="modal-slick">
            <div v-for="n in news.results">
              <div v-if="n.imageThumbUrl" class="image">
                <img :src="n.imageThumbUrl" width="100%">
              </div>
              <div class="text">
                {{ n.title }}
              </div>
              <div class="autor"><a href="#">{{ n.profile }}</a> via {{ n.sourceType }}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Hello from './components/Hello'
import 'slick-carousel/slick/slick'
// import {TweenMax} from "gsap";
// import Vue from 'vue'
import speechAnimation from './assets/bubble.gif'

export default {
  name: 'app',
  components: {
    Hello
  },
  data () {
    return {
      first: true,
      isSpeaking: false,
      input: '',
      conversation: [],
      speakQueue: [],
      params: {},
      streamClient: false,
      isRecognizing: false,
      isRecognizingAndReceivingInput: false,
      isRecognizingLastInput: '',
      recognition: '',
      newsUri: 'https://www.mercedes-benz.com/public-api/social-api/clippings?type=image,video&count=5&offsetUuid=&label=digital-experience-motorsport',
      news: {},
      slick: false,
      nativeSpeech: false,
      nativeVoices: [],
      nativeVoice: {},
      lang: 'en-GB',
      nativeVoiceNr: 49, // en-GB female voice
      nativeVoiceNrAlternative: 32, // en-US Samantha
      nativeVoiceRate: 1,
      nativeVoicePitch: 1,
      speechAnimation: speechAnimation,
      recordedText: ''
    }
  },
  mounted () {
    let app = this
    let Nclass = (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition)
    if (typeof Nclass !== 'undefined') {
      let n = new Nclass()
      n.continuous = false
      n.interimResults = true

      if (typeof n !== 'undefined') {
        n.onstart = function () {
          app.isRecognizing = true
          app.isRecognizingAndReceivingInput = false
          app.isRecognizingLastInput = ''
          console.log('start recording')
        }
        n.onerror = function () {
          app.isRecognizing = false
          app.isRecognizingAndReceivingInput = false
          app.isRecognizingLastInput = ''
        }
        n.onresult = function (n) {
          let text = ''
          let textFinal = ''
          for (let r = n.resultIndex; r < n.results.length; r++) {
            console.log('loop' + n.results[r][0].transcript)
            app.isRecognizingAndReceivingInput = true
            text += n.results[r][0].transcript
            app.isRecognizingLastInput = text
            if (n.results[r].isFinal) {
              textFinal += n.results[r][0].transcript
            }
          }
          if (textFinal) {
            app.writeAndSend(textFinal)
          }
        }
        n.onend = function () {
          app.isRecognizing = false
          app.isRecognizingAndReceivingInput = false
          app.isRecognizingLastInput = ''
        }
        n.lang = this.lang
        // n.lang = window.AGENT_LANGUAGE || 'de-DE'
        this.recognition = n
        console.log(n)
      }
    } else {
      console.log('no audio device')
    }
    app.nativeSpeech = new SpeechSynthesisUtterance()
    setTimeout(function () {
      app.nativeVoices = window.speechSynthesis.getVoices()
      app.nativeVoice = app.nativeVoices.length < app.nativeVoiceNr ? app.nativeVoices[app.nativeVoiceNrAlternative] : app.nativeVoices[app.nativeVoiceNr]
      // use en-US Samantha as alternative, if Google default Female #49 is not available
    }, 50)
  },
  updated () {
  },
  methods: {
    record: function () {
      let app = this
      if (app.first) {
        console.log('first call')
        // window.responsiveVoice.speak('', window.defaultVoice)
        let n = new SpeechSynthesisUtterance('')
        n.voice = this.nativeVoice
        n.rate = this.nativeVoiceRate
        n.pitch = this.nativeVoicePitch
        window.speechSynthesis.speak(n)
        app.first = false
      }
      if (app.recognition && !this.isSpeaking) {
        if (!app.isRecognizing) {
          app.recognition.start()
        } else {
          app.recognition.stop()
        }
      }
    },
    checkInput: function (event) {
      this.input = event.target.value
    },
    inputSubmit: function (event) {
      if (event.keyCode === 13) {
        this.writeAndSend(this.input)
        this.input = ''
      }
    },
    writeAndSend: function (text) {
      this.conversation.push({ who: 'you', text: text })
      this.recordedText = text
      setTimeout(this.resetRecordedText, 4000)
      this.send(text)
    },
    send: function (text) {
      this.$apiAi.textRequest(text)
        .then((response) => this.speech(response))
        .catch((error) => console.log(error))
    },
    speak: function () {
      if (!this.isSpeaking) {
        this.isSpeaking = true
        this.conversation.push(this.speakQueue[0])
        let n = new SpeechSynthesisUtterance(this.speakQueue[0].text)
        n.lang = this.lang
        n.voice = this.nativeVoice
        n.rate = this.nativeVoiceRate
        n.pitch = this.nativeVoicePitch
        n.onend = this.speakDone
        n.onerror = this.speakError
        window.speechSynthesis.speak(n)
      } else {
        console.log('still speaking')
      }
    },
    speakError: function (e) {
      console.log('speak error: ', e)
      this.speakQueue.shift()
      this.isSpeaking = false
      if (this.speakQueue.length) {
        this.speak()
      }
    },
    speakDone: function () {
      this.speakQueue.shift()
      this.isSpeaking = false
      if (this.speakQueue.length) {
        this.speak()
      }
    },
    speech: function (response) {
      let app = this
      if ('result' in response && 'fulfillment' in response.result && 'speech' in response.result.fulfillment) {
        let r = { who: 'bot', text: response.result.fulfillment.speech }
        this.speakQueue.push(r)
        this.speak()
        console.log(response.result)
      }
      if ('result' in response && 'parameters' in response.result) {
        let t = this
        Object.keys(response.result.parameters).forEach(function (paramName, index) {
          t.params[paramName] = response.result.parameters[paramName]
          if (paramName === 'news') {
            app.getNews()
          }
        })
      }
    },
    getNews: function () {
      let app = this
      app.$j.ajax({
        url: app.newsUri,
        success: function (r) {
          app.news = r
          console.log(app.news.results)
          setTimeout(function () {
            let s = app.$j('.modal-slick')
            if (s.length) {
              app.slick = s.slick({
                prevArrow: '<button type="button" class="slick-arrow slick-prev">&laquo;</button>',
                nextArrow: '<button type="button" class="slick-arrow slick-next">&raquo;</button>',
                adaptiveHeight: true
              })
            }
          }, 20)
        }
      })
    },
    closeNews: function () {
      this.news = {}
    },
    updateAnimation: function () {
      window.requestAnimationFrame(this.updateAnimation)
    },
    resetRecordedText: function () {
      this.recordedText = ''
    }
  }
}
</script>


<style lang="scss">
  @import "css/style.scss";
</style>



// WEBPACK FOOTER //
// App.vue?0e32068c